import { IonButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useHistory } from 'react-router';
import { CustomRoutes } from '../../utils/CustomRoutes';
import EditQuestion from '../../components/interview/EditQuestion';
import LoginComponent from '../../components/common/LoginComponent';

const EditQuestionPage: React.FC = () => {
  const history = useHistory();
  const goToViewInterviews = () => {
    history.push(CustomRoutes.viewInterview);
  }
  let orgPageTitle = "Edit Question"
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>
            {orgPageTitle}
          </IonTitle>
          <IonButtons slot='end'>
            <LoginComponent></LoginComponent>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="primary">
            <IonTitle size="large">{orgPageTitle}</IonTitle>
            {/* <IonButton>View Interviews</IonButton> */}
          </IonToolbar>
        </IonHeader>
        <EditQuestion></EditQuestion>
      </IonContent>
    </IonPage>
  );
};

export default EditQuestionPage;
